<template>
  <!--begin::Basic info-->
  <div class="card mb-5 mb-xl-10">
    <!--begin::Content-->
    <EditSubscription></EditSubscription>
    <!--end::Content-->
  </div>
</template>
<script>
import EditSubscription from "@/components/1crm/fitur/management-subscription/edit-subscription.vue";
import { defineComponent, onMounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "add-master-fitur",
  components: {
    EditSubscription,
  },
  setup() {
    const store = useStore();

    onMounted(() => {
      store.dispatch(Actions.VERIFY_AUTH_SEKOLAH);
      setCurrentPageBreadcrumbs("Detail Management Subscription", [
        "Master Fitur",
        "Management Subscription",
      ]);
    });
  },
});
</script>
